import { render, staticRenderFns } from "./SolutionTile.vue?vue&type=template&id=74a3af9f&scoped=true&"
import script from "./SolutionTile.vue?vue&type=script&lang=js&"
export * from "./SolutionTile.vue?vue&type=script&lang=js&"
import style0 from "./SolutionTile.vue?vue&type=style&index=0&id=74a3af9f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74a3af9f",
  null
  
)

export default component.exports